import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-200">
      <div className="w-full px-4 md:px-6">
        <div className="py-14 md:py-16">
          <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
            <div className="lg:w-[40%]">
              <Link to="/" className="inline-block">
                <span className="font-heading text-3xl text-background-50">89890漫画网</span>
              </Link>
              <p className="mt-5 text-sm text-foreground-400 leading-relaxed max-w-md">
                89890漫画网致力于为广大漫画爱好者提供免费、高清、流畅的在线阅读体验。
                收录海量精品漫画，涵盖恋爱、校园、青春、奇幻等丰富题材，每日更新精彩章节。
              </p>
              <div className="mt-8">
                <p className="text-xs text-foreground-500 mb-3 font-medium">订阅我们的更新通知</p>
                <form className="flex flex-col sm:flex-row gap-3" data-readdy-form="">
                  <input
                    type="email"
                    name="email"
                    placeholder="输入您的邮箱地址"
                    required
                    className="flex-1 px-4 py-3 text-sm bg-transparent border-b border-foreground-600 text-background-50 placeholder-foreground-500 focus:outline-none focus:border-primary-400 transition-colors"
                  />
                  <input
                    type="text"
                    name="website_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                    className="honeypot-field"
                  />
                  <button
                    type="submit"
                    className="px-6 py-3 text-sm font-medium border border-primary-500 text-primary-400 rounded-lg hover:bg-primary-500 hover:text-background-50 transition-all cursor-pointer whitespace-nowrap"
                  >
                    订阅
                  </button>
                </form>
              </div>
            </div>

            <div className="flex-1 grid grid-cols-2 sm:grid-cols-3 gap-8">
              <div>
                <h4 className="text-sm font-semibold text-background-50 mb-5">
                  <a href="/category/lianai" className="hover:text-primary-400 transition-colors">热门分类</a>
                </h4>
                <ul className="space-y-3">
                  {categories.slice(0, 4).map((cat) => (
                    <li key={cat.slug}>
                      <Link
                        to={`/category/${cat.slug}`}
                        className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                      >
                        {cat.name}漫画
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
              <div>
                <h4 className="text-sm font-semibold text-background-50 mb-5">
                  <a href="/category/qihuan" className="hover:text-primary-400 transition-colors">更多分类</a>
                </h4>
                <ul className="space-y-3">
                  {categories.slice(4).map((cat) => (
                    <li key={cat.slug}>
                      <Link
                        to={`/category/${cat.slug}`}
                        className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                      >
                        {cat.name}漫画
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
              <div>
                <h4 className="text-sm font-semibold text-background-50 mb-5">
                  <a href="/about" className="hover:text-primary-400 transition-colors">关于我们</a>
                </h4>
                <ul className="space-y-3">
                  <li>
                    <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                      品牌介绍
                    </Link>
                  </li>
                  <li>
                    <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                      联系方式
                    </Link>
                  </li>
                  <li>
                    <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">
                      用户协议
                    </a>
                  </li>
                  <li>
                    <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">
                      隐私政策
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-700/30 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 89890漫画网 版权所有 | 蜜桃少年漫画大结局免费阅读
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-500 hover:text-primary-400 transition-colors" aria-label="微博" rel="nofollow">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-500 hover:text-primary-400 transition-colors" aria-label="微信" rel="nofollow">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-500 hover:text-primary-400 transition-colors" aria-label="QQ" rel="nofollow">
              <i className="ri-qq-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}